<script setup lang="ts">
const mainMagazineStyles = useScrollTransformedStyle({
  multiplierX: -0.1,
  multiplierY: 0.4,
  rotateMultiplier: -0.05,
})

const leftLeafStyles = useScrollTransformedStyle({
  multiplierX: -0.3,
  multiplierY: 0.6,
  rotateMultiplier: 0.08,
})

const rightLeafStyles = useScrollTransformedStyle({
  multiplierX: 0.25,
  multiplierY: 0.35,
  rotateMultiplier: -0.06,
})
</script>

<template>
  <svg class="w-80" width="400" height="400" viewBox="0 0 400 400" fill="none" overflow="visible" xmlns="http://www.w3.org/2000/svg">

    <g :style="leftLeafStyles">
      <path d="M5.00057 163.305C5.00057 163.305 5.45328 187.097 34.3682 205.407C34.3682 205.407 39.4151 193.477 42.8775 191.088C42.8775 191.088 15.2453 181.983 4.99219 163.305H5.00057Z" fill="#20460B" />
      <path d="M5 163.305C5 163.305 13.8279 184.389 54.287 194.475L93.17 144.668C93.17 144.668 75.4639 138.934 43.3716 118L5 163.305Z" fill="#DAFEA4" />
    </g>

    <g :style="mainMagazineStyles">
      <path d="M251.816 249.629C253.303 248.902 253.006 245.239 251.153 241.448C249.299 237.656 246.591 235.172 245.103 235.899C243.616 236.626 243.913 240.289 245.767 244.081C247.62 247.872 250.329 250.356 251.816 249.629Z" fill="#102B09" />
      <path d="M94.8793 251.616L195.266 302.836C195.266 302.836 214.39 257.245 247.87 247.392C247.87 247.392 246.117 242.254 252.193 243.864C275.259 210.608 291.116 202.138 309.874 188.78L189.806 128.801L155.996 186.991L94.8793 251.616Z" fill="#102B09" />
      <path d="M89.0816 234.952L189.079 287.488C189.079 287.488 211.731 250.912 248.906 243.215L157.018 184.636L89.0816 234.952Z" fill="#DFE8FF" />
      <path d="M86.4504 213.068L183.783 267.834C183.783 267.834 220.091 226.171 248.139 242.611L156.993 184.634C156.993 184.634 126.099 177.821 86.4362 213.062L86.4504 213.068Z" fill="#F8F8F8" />
      <path d="M153.174 183.237C153.174 183.237 171.894 138.296 190.592 122.133L290.914 162.155C290.914 162.155 261.528 198.901 248.891 243.209L153.174 183.237Z" fill="#F8F8F8" />
      <path d="M288.554 165.204L299.561 170.912C299.561 170.912 276.39 192.786 248.884 243.213C248.884 243.213 255.405 204.09 288.554 165.204Z" fill="#EFEFEF" />
      <path d="M295.997 174.48L303.061 179.373C303.061 179.373 279.498 195.608 248.893 243.209C248.893 243.209 276.431 190.198 295.997 174.48Z" fill="#DFE8FF" />
      <path d="M153.175 183.237L249.074 243.134C249.074 243.134 249.732 178.319 168.147 149.167L114.441 130.382L153.175 183.237Z" fill="#DFE8FF" />
      <path d="M168.152 149.177C168.152 149.177 203.387 174.327 202.495 188.007C202.495 188.007 226.836 189.02 246.985 225.165C246.985 225.165 233.402 170.997 168.152 149.177Z" fill="white" />
    </g>

    <g :style="rightLeafStyles">
      <path d="M305 217.56C305 217.56 318.86 249.79 358.99 239.16C358.99 239.16 381.87 234.49 394.61 201.93C394.61 201.93 367.62 202.83 352.87 190C352.87 190 342.56 228.36 305.01 217.56H305Z" fill="#DFE8FF" />
      <path d="M311.109 226.75C311.109 226.75 321.309 235.44 333.199 226.75C333.199 226.75 339.989 246.17 363.909 237.42C363.909 237.42 332.209 251.25 311.109 226.75Z" fill="white" />
    </g>
  </svg>
</template>
